import * as ng from 'angular';
import * as _ from 'underscore';

import { PieChart, Dataset } from '..';

ng.module('e360')
   .factory('pieChartGridFactory', pieChartGridFactory);

pieChartGridFactory.$inject = ['instanceServiceFactory'];
function pieChartGridFactory(instanceServiceFactory) {
   return instanceServiceFactory(PieChartGrid);
}

// Requires that object data has properties named surveyResult resultCount and surveyItemDetail
export class PieChartGrid {
   static $inject = ['ds'];

   constructor(private ds:Dataset) { }

   setData(data:any[]) {
      let groups = _.groupBy(data, 'surveyItemName');
      let groupKeys = _.keys(groups);

      // remove current charts
      let parent = ng.element(`#${this.ds.id}`);
      parent.empty();

      // create dom elements for each chart so element size is known on chart create
      for (let key of groupKeys) {
         parent.append(`<div id="${key}" class="chart-component pie-chart"></div>`);
      }

      for (let key of groupKeys) {
         let group = groups[key];

         let chartData = group.map(val => {
            let result = {};
            result[val.surveyItemDetail] = val.surveyResult;
            result['total'] = val.resultCount;
            return result;
         });

         let chart = new PieChart(new Dataset({
            id: key,
            title: group[0].surveyItemDetail
         }));

         chart.setData(chartData);
      }
   }

   onLoadStart() { }

   onLoadFinish() { }
}

export interface PieChartGridFactory {
   ({ds:Dataset}):PieChartGrid;
}
